module.exports = __webpack_public_path__ + "img/christmasisland.b9e58251.svg";